import React, { useEffect, useState } from "react";
import ReimbursementButton from "./ReimbursementButton";
import "./Reimbursement.css";
import { Link } from "react-router-dom";
import ReimbursementBar from "./ReimbursmentBar";
import { Button } from "reactstrap";
import ReimbursementTable from "./ReimbursementTable";
import axios from "axios";
import { UserConsumer } from "../../UserContext";
import { ReimbursementAPIs } from "./MyReimbursementAPI's";
import { Type } from "react-bootstrap-table2-editor";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { AlertPopups } from "../../components/AlertPopups";
import { statusColor } from "../../components/TableStyle";

const MyReimbursement = (props) => {
	let token = null;
	let joiningDate = null;
	let empDepartment = null;
	let history = useHistory();
	let date = new Date();
	let currentYear = date.getFullYear();
	const [monthlyReimburse, setmonthlyReimburse] = useState([]);
	const [generalReimburse, setgeneralReimburse] = useState([]);
	const [reimbursementStatus, setreimbursementStatus] = useState([]);
	const [isDataFound, setIsDataFound] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isGeneralReimbLoading, setIsGeneralReimbLoading] = useState(true);
	const [monthlyReimburseBtn, setmonthlyReimburseBtn] = useState(false);
	const [generalReimburseBtn, setgeneralReimburseBtn] = useState(false);
	const [selectedYear, setSelectedYear] = useState({
		value: date.getFullYear(),
		label: date.getFullYear(),
	});
	const [selectedMonth, setSelectedMonth] = useState({
		value: -1,
		label: "All",
	});
	const [monthChange, setMonthChange] = useState(false);
	const [status, setStatus] = useState({ value: -1, label: "All" });
	const [years, setYears] = useState([]);
	const [pagerData, setPagerData] = useState(null);
	const [allEmployeesList, setAllEmployeesList] = useState([]);
	const [employeeId, setEmployeeId] = useState({ value: -1, label: "All" });
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isDisabled, setIsDisabled] = useState(true);
	const [selectedList, setSelectedList] = useState([]);
	const [yearChange, setYearChange] = useState(false);
	const [masterChecked, setMasterChecked] = useState(false);
	const [
		MonthlyReimbursementTableLoader,
		setMonthlyReimbursementTableLoader,
	] = useState(true);
	const [startDate, setStartDate] = useState(new Date(`${currentYear}-1-1`));
	const [endDate, setEndDate] = useState(date);
	const defaultSorted = [
		{
			dataField: "appliedDate",
			order: "desc",
		},
	];
	const [sortBy, setSortBy] = useState(defaultSorted[0]);

	var getByJoiningDate = years.map((year) => {
		return { value: year, label: year };
	});
	const monthsList = [
		{ value: -1, label: "All" },
		{ value: 1, label: "January" },
		{ value: 2, label: "February" },
		{ value: 3, label: "March" },
		{ value: 4, label: "April" },
		{ value: 5, label: "May" },
		{ value: 6, label: "June" },
		{ value: 7, label: "July" },
		{ value: 8, label: "August" },
		{ value: 9, label: "September" },
		{ value: 10, label: "October" },
		{ value: 11, label: "November" },
		{ value: 12, label: "December" },
	];

	useEffect(() => {
		if (empDepartment === "5") setNumberOfItemsPerPage(200);
		else setNumberOfItemsPerPage(20);
		const list = [];
		do {
			list.unshift({ value: joiningDate, label: joiningDate.toString() });
			joiningDate++;
		} while (joiningDate != currentYear + 1);
		setYears(list);

		if (props.location.state?.path === "generalReimbursement") {
			if (empDepartment === "5") {
				getAllEmpGeneralReimbursementList();
			} else {
				getGeneralReimburse();
			}
		} else {
			if (empDepartment === "5") {
				getAllEmpMonthlyReimbursementList();
			} else {
				getmonthlyReimburse();
			}
		}
		getReimbursementStatus();
		getAllEmployeeList();
	}, []);
	//API to GetMonthly Reimbursements
	const getmonthlyReimburse = () => {
		setPageNum(1);
		setPagerData([]);
		setIsDisabled(true);
		setMonthlyReimbursementTableLoader(true);

		//Filteration Reset
		setStatus(
			sessionStorage.getItem("MyMonthlyReimbFilter")
				? JSON.parse(sessionStorage.getItem("MyMonthlyReimbFilter"))[0]
					? JSON.parse(
							sessionStorage.getItem("MyMonthlyReimbFilter")
					  )[0]
					: { value: -1, label: "All" }
				: { value: -1, label: "All" }
		);
		setSelectedYear(
			sessionStorage.getItem("MyMonthlyReimbFilter")
				? JSON.parse(sessionStorage.getItem("MyMonthlyReimbFilter"))[1]
					? JSON.parse(
							sessionStorage.getItem("MyMonthlyReimbFilter")
					  )[1]
					: {
							value: date.getFullYear(),
							label: date.getFullYear(),
					  }
				: {
						value: date.getFullYear(),
						label: date.getFullYear(),
				  }
		);
		setSelectedMonth({
			value: -1,
			label: "All",
		});
		setStartDate(new Date(`${currentYear}-1-1`));
		setEndDate(new Date(`${currentYear}-12-31`));
		setEmployeeId({ value: -1, label: "All" });

		empDepartment === "5"
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=-1&PageSize=${200}&PageNumber=1&Year=${new Date().getFullYear()}&Month=${-1}&SortBy=${
							sortBy.dataField
						}_${sortBy.order}&EmployeeId=${-1}&StartDate=${moment(
							startDate
						).format("YYYY-MM-DD")}&EndDate=${moment(
							endDate
						).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then((res) => {
						setIsDataFound(true);
						setIsLoading(false);
						setmonthlyReimburse(res.data.reimbursements);
						setMonthlyReimbursementTableLoader(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
					})
			: axios
					.get(
						`${
							ReimbursementAPIs.GetMonthlyReimbursement
						}?PageSize=${numberOfItemsPerPage}&PageNumber=1&Status=-1&Year=${
							sessionStorage.getItem("MyMonthlyReimbFilter")
								? JSON.parse(
										sessionStorage.getItem(
											"MyMonthlyReimbFilter"
										)
								  )[1]
									? JSON.parse(
											sessionStorage.getItem(
												"MyMonthlyReimbFilter"
											)
									  )[1].value
									: date.getFullYear()
								: date.getFullYear()
						}`,
						{
							headers: { Authorization: `Bearer ${token}` },
						}
					)
					.then((res) => {
						if (res.status === 200) {
							setIsLoading(false);
							setMonthlyReimbursementTableLoader(false);
							setmonthlyReimburse(res.data.reimbursements);
						}
						if (res.data.reimbursements.length) {
							setIsDataFound(true);
						}
					});
		setgeneralReimburse(null);
		setmonthlyReimburseBtn(true);
		setgeneralReimburseBtn(false);
		setSelectedList([]);
		setMasterChecked(false);
	};

	//API to GetGeneral Reimbursements
	const getGeneralReimburse = () => {
		setPageNum(1);
		setPagerData([]);
		setgeneralReimburse([]);
		setIsGeneralReimbLoading(true);

		//Filteration Reset
		setStatus(
			sessionStorage.getItem("MyGeneralReimbFilter")
				? JSON.parse(sessionStorage.getItem("MyGeneralReimbFilter"))[0]
					? JSON.parse(
							sessionStorage.getItem("MyGeneralReimbFilter")
					  )[0]
					: { value: -1, label: "All" }
				: { value: -1, label: "All" }
		);
		setSelectedYear(
			sessionStorage.getItem("MyGeneralReimbFilter")
				? JSON.parse(sessionStorage.getItem("MyGeneralReimbFilter"))[1]
					? JSON.parse(
							sessionStorage.getItem("MyGeneralReimbFilter")
					  )[1]
					: {
							value: date.getFullYear(),
							label: date.getFullYear(),
					  }
				: {
						value: date.getFullYear(),
						label: date.getFullYear(),
				  }
		);

		empDepartment === "5"
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpGeneralReimbursementList
						}?Status=${
							status.value
						}&PageSize=${200}&PageNumber=1&Year=${
							selectedYear.value
						}&SortBy=${sortBy.dataField}_${
							sortBy.order
						}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setgeneralReimburse(data.reimbursements);
						setIsGeneralReimbLoading(false);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: axios
					.get(
						`${
							ReimbursementAPIs.GetGeneralReimbursement
						}?PageSize=20&Status=${
							sessionStorage.getItem("MyGeneralReimbFilter")
								? JSON.parse(
										sessionStorage.getItem(
											"MyGeneralReimbFilter"
										)
								  )[0]
									? JSON.parse(
											sessionStorage.getItem(
												"MyGeneralReimbFilter"
											)
									  )[0].value
									: -1
								: -1
						}&SortBy=${sortBy.dataField}_${sortBy.order}
						&Year=${
							sessionStorage.getItem("MyGeneralReimbFilter")
								? JSON.parse(
										sessionStorage.getItem(
											"MyGeneralReimbFilter"
										)
								  )[1]
									? JSON.parse(
											sessionStorage.getItem(
												"MyGeneralReimbFilter"
											)
									  )[1].value
									: date.getFullYear()
								: date.getFullYear()
						}`,
						{
							headers: { Authorization: `Bearer ${token}` },
						}
					)
					.then((res) => {
						if (res.data.reimbursements.length) {
							setIsDataFound(true);
							setPagerData(
								JSON.parse(res.headers["x-pagination"])
							);
							setIsGeneralReimbLoading(false);
							setgeneralReimburse(res.data.reimbursements);
						}
					});
		setmonthlyReimburse(null);
		setmonthlyReimburseBtn(false);
		setgeneralReimburseBtn(true);
	};

	//API to GetStatus
	const getReimbursementStatus = () => {
		axios
			.get(`${ReimbursementAPIs.GetReimbursementStatus}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				setreimbursementStatus(
					res.data.statusTypes.sort((a, b) =>
						a.label.localeCompare(b.label)
					)
				);
			});
	};

	const handleStatus = (obj) => {
		setStatus(obj);
		setPageNum(1);
		setIsLoading(true);
		setIsGeneralReimbLoading(true);
		setMonthlyReimbursementTableLoader(true);
		storeFiltersStates(obj, "status");

		empDepartment === "5" &&
		employeeId &&
		selectedMonth &&
		selectedYear &&
		monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${
							obj.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&Month=${selectedMonth.value}&StartDate=${moment(
							startDate
						).format("YYYY-MM-DD")}&EndDate=${moment(
							endDate
						).format("YYYY-MM-DD")}&EmployeeID=${employeeId.value}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setmonthlyReimburse(data.reimbursements);
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setmonthlyReimburseBtn(true);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: empDepartment === "5" &&
			  employeeId &&
			  selectedMonth &&
			  monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${
							obj.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&Month=${selectedMonth.value}&EmployeeID=${
							employeeId.value
						}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setmonthlyReimburse(data.reimbursements);
						setmonthlyReimburseBtn(true);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: empDepartment === "5" && selectedMonth && monthlyReimburse
			? axios
					.get(
						`${ReimbursementAPIs.GetAllEmpMonthlyReimbursementList}?Status=${obj.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&Year=${selectedYear.value}&Month=${selectedMonth.value}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setmonthlyReimburse(data.reimbursements);
						setmonthlyReimburseBtn(true);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: empDepartment === "5" && employeeId && monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${
							obj.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&EmployeeID=${employeeId.value}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setmonthlyReimburse(data.reimbursements);
						setmonthlyReimburseBtn(true);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: empDepartment === "5" && monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${
							obj.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&Month=${selectedMonth.value}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setmonthlyReimburse(data.reimbursements);
						setmonthlyReimburseBtn(true);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: monthlyReimburse
			? axios
					.get(
						`${ReimbursementAPIs.GetMonthlyReimbursement}?Status=${obj.value}&Year=${selectedYear.value}&PageSize=20`,
						{
							headers: { Authorization: `Bearer ${token}` },
						}
					)
					.then((res) => {
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setmonthlyReimburse(res.data.reimbursements);
					})
			: empDepartment === "5" && generalReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpGeneralReimbursementList
						}?Status=${
							obj.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&Month=${selectedMonth.value}&SortBy=${
							sortBy.dataField
						}_${sortBy.order}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format(
							"YYYY-MM-DD"
						)}&EmployeeID=${employeeId.value}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setgeneralReimburse(data.reimbursements);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: axios
					.get(
						`${ReimbursementAPIs.GetGeneralReimbursement}?Status=${obj.value}&Year=${selectedYear.value}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`,
						{
							headers: { Authorization: `Bearer ${token}` },
						}
					)
					.then((res) => {
						setIsLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setgeneralReimburse(res.data.reimbursements);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
					});
	};

	//API Integration for By Year Hanlder
	const byYearHandler = (obj) => {
		let selectedYear = obj.value;
		let newStartDate = null;
		let newEndDate = null;
		setIsGeneralReimbLoading(true);
		setMonthlyReimbursementTableLoader(true);
		storeFiltersStates(obj, "year");

		if (selectedYear === date.getFullYear()) {
			newStartDate = new Date(`${selectedYear}-1-1`);
			newEndDate = new Date();
			setStartDate(newStartDate);
			setEndDate(newEndDate);
		} else {
			newStartDate = new Date(`${selectedYear}-1-1`);
			newEndDate = new Date(`${selectedYear}-12-31`);
			setStartDate(newStartDate);
			setEndDate(newEndDate);
		}

		setYearChange(true);
		setPageNum(1);
		setSelectedYear({ value: selectedYear, label: obj.label });
		empDepartment === "5" && employeeId && monthChange && monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${
							status.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							obj.label
						}&EmployeeID=${employeeId.value}&Month=${
							selectedMonth.value
						}&StartDate=${moment(newStartDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(newEndDate).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data }) => {
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setmonthlyReimburse(data.reimbursements);
						setmonthlyReimburseBtn(true);
					})
			: empDepartment === "5" &&
			  employeeId &&
			  selectedMonth &&
			  empDepartment === "5" &&
			  monthChange &&
			  !employeeId &&
			  monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${status.value}&StartDate=${moment(
							newStartDate
						).format("YYYY-MM-DD")}&EndDate=${moment(
							newEndDate
						).format(
							"YYYY-MM-DD"
						)}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							obj.label
						}&Month=${selectedMonth.value}&SortBy=${
							sortBy.dataField
						}_${sortBy.order}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setMonthlyReimbursementTableLoader(false);
						setIsGeneralReimbLoading(false);
						setmonthlyReimburse(data.reimbursements);
						setPagerData(JSON.parse(headers["x-pagination"]));
						setmonthlyReimburseBtn(true);
					})
			: empDepartment === "5" &&
			  !monthlyReimburse &&
			  selectedMonth &&
			  axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpGeneralReimbursementList
						}?Status=${
							status.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							obj.label
						}&Month=${selectedMonth.value}&SortBy=${
							sortBy.dataField
						}_${sortBy.order}&StartDate=${moment(
							newStartDate
						).format("YYYY-MM-DD")}&EndDate=${moment(
							newEndDate
						).format("YYYY-MM-DD")}&EmployeeID=${employeeId.value}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setgeneralReimburse(data.reimbursements);
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setPagerData(JSON.parse(headers["x-pagination"]));
						setmonthlyReimburseBtn(false);
					});
		empDepartment === "5" && employeeId && !monthChange && monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${status.value}&Month=${
							selectedMonth.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							obj.label
						}&EmployeeID=${employeeId.value}&StartDate=${moment(
							newStartDate
						).format("YYYY-MM-DD")}&EndDate=${moment(
							newEndDate
						).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setPagerData(JSON.parse(headers["x-pagination"]));
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setmonthlyReimburse(data.reimbursements);
						setmonthlyReimburseBtn(true);
					})
			: empDepartment === "5" &&
			  !monthlyReimburse &&
			  employeeId &&
			  monthChange &&
			  axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpGeneralReimbursementList
						}?Status=${status.value}&StartDate=${moment(
							newStartDate
						).format("YYYY-MM-DD")}&EndDate=${moment(
							newEndDate
						).format(
							"YYYY-MM-DD"
						)}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Month=${
							selectedMonth.value
						}&Year=${obj.label}&EmployeeID=${
							employeeId.value
						}&SortBy=${sortBy.dataField}_${sortBy.order}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setPagerData(JSON.parse(headers["x-pagination"]));
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setgeneralReimburse(data.reimbursements);
						setmonthlyReimburseBtn(false);
					});
		empDepartment === "5" && !employeeId && !monthChange && monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${
							status.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							obj.label
						}&Month=${selectedMonth.value}&SortBy=${
							sortBy.dataField
						}_${sortBy.order}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setmonthlyReimburse(data.reimbursements);
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setmonthlyReimburseBtn(true);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: monthlyReimburse && empDepartment != "5"
			? axios
					.get(
						`${ReimbursementAPIs.GetMonthlyReimbursement}?Status=${
							status.value
						}&Year=${
							obj.label
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&SortBy=${
							sortBy.dataField
						}_${sortBy.order}`,
						{
							headers: { Authorization: `Bearer ${token}` },
						}
					)
					.then((res) => {
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setmonthlyReimburse(res.data.reimbursements);
					})
			: empDepartment != "5" &&
			  !monthlyReimburse &&
			  axios
					.get(
						`${ReimbursementAPIs.GetGeneralReimbursement}?Status=${
							status.value
						}&Year=${
							obj.label
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}`,
						{
							headers: { Authorization: `Bearer ${token}` },
						}
					)
					.then((res) => {
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setgeneralReimburse(res.data.reimbursements);
					});
	};

	const viewMonthlyReimburseDetails = (id, submissionStatus) => {
		history.push({
			pathname: `/monthlyReimbursement/${id}`,
			state: {
				status: submissionStatus,
				selectedMonth: selectedMonth,
				selectedYear: selectedYear,
				employeeId: employeeId,
				status: status,
			},
		});
	};
	const viewGeneralReimburseDetails = (id, status) => {
		history.push({
			pathname: `/generalReimbursement/${id}`,
			state: {
				status: status,
			},
		});
	};
	const pageSizeOptions = [
		{ value: 10, label: 10 },
		{ value: 20, label: 20 },
		{ value: 50, label: 50 },
		{ value: 100, label: 100 },
	];
	const columns = [
		{
			dataField: "appID",
			text: "Token#",
			sort: false,
			formatter: (cell, row) => {
				const { appID, submissionStatus } = row;
				return (
					<Link
						className="tokenNumber"
						style={{ fontWeight: "bolder" }}
						to={{
							pathname: `/generalReimbursement/${cell}`,
							state: {
								status: submissionStatus,
							},
						}}
					>
						<span className="ticketIdStyle">#{cell}</span>
					</Link>
				);
			},
		},
		{
			dataField: "appliedDate",
			text: "Created Date",
			sort: true,
			formatter: (cell) => {
				return moment(cell).format("DD/MM/YYYY");
			},
		},
		{
			dataField: "submissionStatus",
			text: "Status",
			sort: false,
			style: statusColor,
		},
		{
			dataField: "grandTotal",
			text: "Grand Total",
			sort: false,
			formatter: (cell, row) => {
				return row.grandTotal.toLocaleString();
			},
		},
	];
	const columnsForFinance = [
		{
			dataField: "checkbox",
			text: (
				<input
					type="checkbox"
					onChange={(e) => onMasterCheck(e)}
					checked={masterChecked}
				/>
			),
			sort: false,
			editor: {
				type: Type.CHECKBOX,
				value: "Y:N",
			},
			formatter: (cell, row) => {
				const { selected } = row;
				return (
					<input
						type="checkbox"
						onChange={() => getSpecificReimbursementRecord(row)}
						checked={selected ? selected : cell}
					/>
				);
			},
		},
		{
			dataField: "appID",
			text: "Token#",
			sort: true,
			formatter: (cell, row) => {
				const { appID, submissionStatus } = row;
				return (
					<Link
						className="tokenNumber"
						style={{ fontWeight: "bolder" }}
						to={{
							pathname: `/generalReimbursement/${cell}`,
							state: {
								status: submissionStatus,
							},
						}}
					>
						<span className="ticketIdStyle">#{cell}</span>
					</Link>
				);
			},
		},
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
		},
		{
			dataField: "appliedDate",
			text: "Created Date",
			sort: false,
			formatter: (cell) => {
				return moment(cell).format("DD/MM/YYYY");
			},
		},
		{
			dataField: "submissionStatus",
			text: "Status",
			sort: false,
			style: statusColor,
		},
		{
			dataField: "grandTotal",
			text: "Grand Total",
			sort: false,
			formatter: (cell, row) => {
				return row.grandTotal.toLocaleString();
			},
		},
	];

	const [isLoaded, setIsLoaded] = useState(false);
	const [pageNum, setPageNum] = useState(1);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		empDepartment === "5" ? 200 : 20
	);

	const menuProps = [
		{ value: 10, label: "10" },
		{ value: 20, label: "20" },
		{ value: 50, label: "50" },
	];
	const adminMenuProps = [
		{ value: 10, label: "10" },
		{ value: 20, label: "20" },
		{ value: 50, label: "50" },
		{ value: 100, label: "100" },
		{ value: 200, label: "200" },
	];

	const receiveData = (PageSize) => {
		setIsLoaded(false);
		setIsLoading(true);
		setIsGeneralReimbLoading(true);
		setMonthlyReimbursementTableLoader(true);
		!monthlyReimburse
			? empDepartment === "5"
				? !monthChange
					? axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpGeneralReimbursementList
								}?PageSize=${PageSize}&PageNumber=${1}&Status=${
									status.value
								}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&Month=${selectedMonth.value}&Year=${
									selectedYear.value
								}&EmployeeID=${
									employeeId.value
								}&StartDate=${moment(startDate).format(
									"YYYY-MM-DD"
								)}&EndDate=${moment(endDate).format(
									"YYYY-MM-DD"
								)}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then((res) => {
								if (res.status === 200) {
									setIsLoading(false);
									setPageNum(1);
									setNumberOfItemsPerPage(PageSize);
									setgeneralReimburse(
										res.data.reimbursements
									);
									setIsGeneralReimbLoading(false);
									setMonthlyReimbursementTableLoader(false);
									setPagerData(
										JSON.parse(res.headers["x-pagination"])
									);
								}
							})
					: !employeeId
					? axios
							.get(
								`${ReimbursementAPIs.GetAllEmpGeneralReimbursementList}?PageSize=${PageSize}&Status=${status.value}&SortBy=${sortBy.dataField}_${sortBy.order}&Year=${selectedYear.value}&Month=${selectedMonth.value}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then((res) => {
								if (res.status === 200) {
									setIsLoading(false);
									setPageNum(1);
									setNumberOfItemsPerPage(PageSize);
									setIsGeneralReimbLoading(false);
									setMonthlyReimbursementTableLoader(false);
									setgeneralReimburse(
										res.data.reimbursements
									);
									setPagerData(
										JSON.parse(res.headers["x-pagination"])
									);
								}
							})
					: axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpGeneralReimbursementList
								}?PageSize=${PageSize}&StartDate=${moment(
									startDate
								).format("YYYY-MM-DD")}&EndDate=${moment(
									endDate
								).format("YYYY-MM-DD")}&Status=${
									status.value
								}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}&EmployeeId=${employeeId.value}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then((res) => {
								if (res.status === 200) {
									setIsLoading(false);
									setPageNum(1);
									setIsGeneralReimbLoading(false);
									setMonthlyReimbursementTableLoader(false);
									setNumberOfItemsPerPage(PageSize);
									setgeneralReimburse(
										res.data.reimbursements
									);
									setPagerData(
										JSON.parse(res.headers["x-pagination"])
									);
								}
							})
				: axios
						.get(
							`${ReimbursementAPIs.GetGeneralReimbursement}?PageSize=${PageSize}&Status=${status.value}&SortBy=${sortBy.dataField}_${sortBy.order}&Year=${selectedYear.value}`,
							{
								headers: { Authorization: `Bearer ${token}` },
							}
						)
						.then((res) => {
							if (res.status === 200) {
								setIsLoading(false);
								setPageNum(1);
								setIsGeneralReimbLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setNumberOfItemsPerPage(PageSize);
								setgeneralReimburse(res.data.reimbursements);
								setPagerData(
									JSON.parse(res.headers["x-pagination"])
								);
							}
						})
			: axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?PageSize=${PageSize}&Status=${status.value}&SortBy=${
							sortBy.dataField
						}_${sortBy.order}&Month=${
							selectedMonth.value
						}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
						{
							headers: { Authorization: `Bearer ${token}` },
						}
					)
					.then((res) => {
						if (res.status === 200) {
							setIsLoading(false);
							setPageNum(1);
							setIsGeneralReimbLoading(false);
							setMonthlyReimbursementTableLoader(false);
							setNumberOfItemsPerPage(PageSize);
							setmonthlyReimburse(res.data.reimbursements);
							setPagerData(
								JSON.parse(res.headers["x-pagination"])
							);
						}
					});
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setgeneralReimburse([]);
		setMasterChecked(false);
		setIsGeneralReimbLoading(true);
		setIsLoaded(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			apiURL =
				empDepartment === "5"
					? `${
							ReimbursementAPIs.GetAllEmpGeneralReimbursementList
					  }?Status=${
							status.value
					  }&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Year=${
							selectedYear.value
					  }&SortBy=${sortBy.dataField}_${sortBy.order}&EmployeeID=${
							employeeId.value
					  }&Month=${selectedMonth.value}&StartDate=${moment(
							startDate
					  ).format("YYYY-MM-DD")}&EndDate=${moment(endDate).format(
							"YYYY-MM-DD"
					  )}`
					: `${ReimbursementAPIs.GetGeneralReimbursement}?Year=${selectedYear.value}&PageSize=${numberOfItemsPerPage}&Status=${status.value}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}&EmployeeID=${employeeId.value}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL =
				empDepartment === "5"
					? !monthChange
						? `${
								ReimbursementAPIs.GetAllEmpGeneralReimbursementList
						  }?Status=${
								status.value
						  }&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Year=${
								selectedYear.value
						  }&EmployeeID=${employeeId.value}&StartDate=${moment(
								startDate
						  ).format("YYYY-MM-DD")}&EndDate=${moment(
								endDate
						  ).format("YYYY-MM-DD")}&Month=${
								selectedMonth.value
						  }&SortBy=${sortBy.dataField}_${sortBy.order}`
						: !employeeId
						? `${ReimbursementAPIs.GetAllEmpGeneralReimbursementList}?Status=${status.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Year=${selectedYear.value}&Month=${selectedMonth.value}&EmployeeID=${employeeId.value}`
						: `${
								ReimbursementAPIs.GetAllEmpGeneralReimbursementList
						  }?Status=${status.value}&StartDate=${moment(
								startDate
						  ).format("YYYY-MM-DD")}&EndDate=${moment(
								endDate
						  ).format(
								"YYYY-MM-DD"
						  )}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Year=${
								selectedYear.value
						  }&Month=${selectedMonth.value}&EmployeeId=${
								employeeId.value
						  }`
					: `${ReimbursementAPIs.GetGeneralReimbursement}?Year=${selectedYear.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${status.value}&SortBy=${sortBy.dataField}_${sortBy.order}&EmployeeID=${employeeId.value}`;
			getData = true;
		}

		if (getData) {
			setMonthlyReimbursementTableLoader(true);
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setgeneralReimburse(res.data.reimbursements);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
					}
				});
		}
	};

	//APIs Integration For Finance Department
	const getAllEmpMonthlyReimbursementList = (page) => {
		setIsLoading(true);
		setgeneralReimburse(null);
		setMonthlyReimbursementTableLoader(true);
		monthChange
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${status.value}&PageSize=${
							empDepartment === "5" ? 200 : 20
						}&PageNumber=${pageNum}&Year=${
							selectedYear.value
						}&Month=${selectedMonth.value}&SortBy=${
							sortBy.dataField
						}_${sortBy.order}&EmployeeID=${
							employeeId.value
						}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setmonthlyReimburse(data.reimbursements);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: !yearChange
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${status.value}&PageSize=${
							empDepartment === "5" ? 200 : 20
						}&PageNumber=${pageNum}&Year=${
							selectedYear.value
						}&Month=${selectedMonth.value}&SortBy=${
							sortBy.dataField
						}_${sortBy.order}&EmployeeID=${
							employeeId.value
						}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setMonthlyReimbursementTableLoader(false);
						setIsDataFound(true);
						setIsLoaded(true);
						setIsLoading(false);
						setmonthlyReimburse(data.reimbursements);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${status.value}&Month=${
							selectedMonth.value
						}&PageSize=${
							empDepartment === "5" ? 200 : 20
						}&PageNumber=${pageNum}&Year=${
							selectedYear.value
						}&SortBy=${sortBy.dataField}_${
							sortBy.order
						}&EmployeeID=${employeeId.value}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setmonthlyReimburse(data.reimbursements);
						setPagerData(JSON.parse(headers["x-pagination"]));
					});
		setmonthlyReimburseBtn(true);
		setmonthlyReimburseBtn(true);
	};

	const getAllEmpGeneralReimbursementList = () => {
		setPageNum(1);
		setmonthlyReimburse(null);
		setIsDisabled(true);
		setIsLoading(true);
		setIsGeneralReimbLoading(true);

		//Filteration Reset
		setStartDate(new Date(`${currentYear}-1-1`));
		setEndDate(new Date(`${currentYear}-12-31`));
		setStatus({ value: -1, label: "All" });
		setSelectedYear({
			value: new Date().getFullYear(),
			label: new Date().getFullYear(),
		});
		setSelectedMonth({
			value: -1,
			label: "All",
		});
		setEmployeeId({ value: -1, label: "All" });

		axios
			.get(
				`${
					ReimbursementAPIs.GetAllEmpGeneralReimbursementList
				}?Status=-1&PageSize=${
					empDepartment === "5" ? 200 : 20
				}&PageNumber=${pageNum}&Month=${selectedMonth.value}&Year=${
					selectedYear.value
				}&SortBy=${sortBy.dataField}_${sortBy.order}&EmployeeID=${
					employeeId.value
				}&StartDate=${moment(startDate).format(
					"YYYY-MM-DD"
				)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data, headers }) => {
				setgeneralReimburse(data.reimbursements);
				setIsGeneralReimbLoading(false);
				setmonthlyReimburseBtn(false);
				setPagerData(JSON.parse(headers["x-pagination"]));
				setIsLoading(false);
			});

		setmonthlyReimburseBtn(false);
		setgeneralReimburseBtn(true);
		setSelectedList([]);
		setMultipleRecords([]);
	};
	const getAllEmployeeList = () => {
		axios
			.get(`${ReimbursementAPIs.GetAllEmployees}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				const sendData = [];
				if (data) {
					data.forEach((item) =>
						sendData.push({
							label: item.name,
							value: item.employeeId,
						})
					);
				}

				sendData.unshift({ value: -1, label: "All" });
				setAllEmployeesList(sendData);
			});
	};

	let employeesList = allEmployeesList.map((item) => {
		return { value: item.employeeId, label: item.name };
	});
	const getEmployeeID = (obj) => {
		setIsLoading(true);
		setPageNum(1);
		setIsGeneralReimbLoading(true);
		setMonthlyReimbursementTableLoader(true);
		setEmployeeId({ value: obj.value, label: obj.label });
		empDepartment === "5" && monthChange && obj.value && monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${
							status.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&EmployeeID=${obj.value}&Month=${
							selectedMonth.value
						}&SortBy=${sortBy.dataField}_${
							sortBy.order
						}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setmonthlyReimburse(data.reimbursements);
						setmonthlyReimburseBtn(true);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: empDepartment === "5" &&
			  !monthlyReimburse &&
			  status &&
			  selectedMonth &&
			  selectedYear &&
			  axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpGeneralReimbursementList
						}?Status=${
							status.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&EmployeeID=${obj.value}&Month=${
							selectedMonth.value
						}&SortBy=${sortBy.dataField}_${
							sortBy.order
						}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setgeneralReimburse(data.reimbursements);
						setmonthlyReimburseBtn(false);
						setPagerData(JSON.parse(headers["x-pagination"]));
					});
		!monthChange &&
			monthlyReimburse &&
			axios
				.get(
					`${
						ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
					}?Status=${
						status.value
					}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
						selectedYear.value
					}&Month=${selectedMonth.value}&EmployeeID=${
						obj.value
					}&SortBy=${sortBy.dataField}_${
						sortBy.order
					}&StartDate=${moment(startDate).format(
						"YYYY-MM-DD"
					)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
					{ headers: { Authorization: `Bearer ${token}` } }
				)
				.then(({ data, headers }) => {
					setIsLoading(false);
					setIsGeneralReimbLoading(false);
					setMonthlyReimbursementTableLoader(false);
					setmonthlyReimburse(data.reimbursements);
					setmonthlyReimburseBtn(true);
					setPagerData(JSON.parse(headers["x-pagination"]));
				});
	};
	const [singleRecordID, setSingleRecordID] = useState([]);
	const [submissionStatus, setSubmissionStatus] = useState();
	const [multipleRecords, setMultipleRecords] = useState([]);

	const getSpecificReimbursementRecord = (obj) => {
		{
			monthlyReimburse && setgeneralReimburse(null);
		}
		setSingleRecordID(obj.appID);
		setMultipleRecords([...multipleRecords, { obj }]);
		if (obj.selected) {
			obj.selected = false;
			setIsDisabled(true);
		} else {
			obj.selected = true;
			setIsDisabled(false);
		}
		monthlyReimburse
			? setMultipleRecords(monthlyReimburse.filter((e) => e.selected))
			: setMultipleRecords(generalReimburse.filter((e) => e.selected));
		setSelectedList([...selectedList, { appID: obj.appID }]);
		if (selectedList.length < 1) {
			setSingleRecordID(obj.appID);
		} else {
			selectedList.map((item) => {
				return obj.appID === item.appID
					? setSelectedList([...selectedList])
					: setSelectedList([...selectedList, { appID: obj.appID }]);
			});
		}
	};

	const byMonthHanlder = (obj) => {
		setPageNum(1);
		setMonthChange(true);
		setIsLoading(true);
		setSelectedMonth(obj);
		setIsGeneralReimbLoading(true);
		setMonthlyReimbursementTableLoader(true);

		empDepartment === "5" && employeeId && monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${
							status.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&EmployeeID=${employeeId.value}&Month=${
							obj.value
						}&SortBy=${sortBy.dataField}_${
							sortBy.order
						}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setPagerData(JSON.parse(headers["x-pagination"]));
						setmonthlyReimburse(data.reimbursements);
					})
			: empDepartment === "5" &&
			  generalReimburse &&
			  employeeId &&
			  selectedMonth &&
			  selectedYear &&
			  axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpGeneralReimbursementList
						}?Status=${
							status.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&EmployeeID=${employeeId.value}&Month=${
							obj.value
						}&SortBy=${sortBy.dataField}_${
							sortBy.order
						}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setgeneralReimburse(data.reimbursements);
						setPagerData(JSON.parse(headers["x-pagination"]));
					});
		empDepartment === "5" && !employeeId && monthlyReimburse
			? axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
						}?Status=${
							status.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&Month=${obj.value}&SortBy=${sortBy.dataField}_${
							sortBy.order
						}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setmonthlyReimburse(data.reimbursements);
						setPagerData(JSON.parse(headers["x-pagination"]));
					})
			: !employeeId &&
			  axios
					.get(
						`${
							ReimbursementAPIs.GetAllEmpGeneralReimbursementList
						}?Status=${
							status.value
						}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${
							selectedYear.value
						}&Month=${obj.value}&SortBy=${sortBy.dataField}_${
							sortBy.order
						}`,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(({ data, headers }) => {
						setIsLoading(false);
						setIsGeneralReimbLoading(false);
						setMonthlyReimbursementTableLoader(false);
						setgeneralReimburse(data.reimbursements);
						setmonthlyReimburseBtn(false);
						setPagerData(JSON.parse(headers["x-pagination"]));
					});
	};
	const paginateLeft = () => {
		setIsLoading(true);
		setPageNum(pageNum - 1);
		if (pageNum > 0) {
			setMonthlyReimbursementTableLoader(true);
			setIsGeneralReimbLoading(true);

			if (empDepartment === "5") {
				!monthChange
					? axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum - 1
								}&EmployeeId=${employeeId.value}&Month=${
									selectedMonth.value
								}&Year=${selectedYear.value}&StartDate=${moment(
									startDate
								).format("YYYY-MM-DD")}&EndDate=${moment(
									endDate
								).format("YYYY-MM-DD")}&SortBy=${
									sortBy.dataField
								}_${sortBy.order}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setIsGeneralReimbLoading(false);
								setmonthlyReimburse(data.reimbursements);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
								setmonthlyReimburseBtn(true);
							})
					: !employeeId && monthChange
					? axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum - 1
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&StartDate=${moment(startDate).format(
									"YYYY-MM-DD"
								)}&EndDate=${moment(endDate).format(
									"YYYY-MM-DD"
								)}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setIsGeneralReimbLoading(false);
								setmonthlyReimburse(data.reimbursements);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
								setmonthlyReimburseBtn(true);
							})
					: axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum - 1
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}&EmployeeId=${
									employeeId.value
								}&StartDate=${moment(startDate).format(
									"YYYY-MM-DD"
								)}&EndDate=${moment(endDate).format(
									"YYYY-MM-DD"
								)}&SortBy=${sortBy.dataField}_${sortBy.order}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setIsGeneralReimbLoading(false);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
								setmonthlyReimburse(data.reimbursements);
								setmonthlyReimburseBtn(true);
							});
			} else {
				!monthChange
					? axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum - 1
								}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&Year=${selectedYear.value}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setIsGeneralReimbLoading(false);
								setmonthlyReimburse(data.reimbursements);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
								setmonthlyReimburseBtn(true);
							})
					: !employeeId && monthChange
					? axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum - 1
								}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setIsGeneralReimbLoading(false);
								setmonthlyReimburse(data.reimbursements);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
								setmonthlyReimburseBtn(true);
							})
					: axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${status.value}&SortBy=${
									sortBy.dataField
								}_${
									sortBy.order
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum - 1
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}&EmployeeId=${employeeId.value}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setIsGeneralReimbLoading(false);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
								setmonthlyReimburse(data.reimbursements);
								setmonthlyReimburseBtn(true);
							});
			}
		}
	};
	const paginateRight = () => {
		setIsLoading(true);
		setMasterChecked(false);
		setPageNum(pageNum + 1);
		setIsGeneralReimbLoading(true);

		if (pageNum >= 0) {
			setMonthlyReimbursementTableLoader(true);

			if (empDepartment === "5") {
				!monthChange
					? axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum + 1
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}&EmployeeId=${employeeId.value}&SortBy=${
									sortBy.dataField
								}_${sortBy.order}&StartDate=${moment(
									startDate
								).format("YYYY-MM-DD")}&EndDate=${moment(
									endDate
								).format("YYYY-MM-DD")}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
								setIsGeneralReimbLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setmonthlyReimburse(data.reimbursements);
								setmonthlyReimburseBtn(true);
							})
					: !employeeId && monthChange
					? axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum + 1
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}&StartDate=${moment(startDate).format(
									"YYYY-MM-DD"
								)}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&EndDate=${moment(endDate).format(
									"YYYY-MM-DD"
								)}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setIsGeneralReimbLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setmonthlyReimburse(data.reimbursements);
								setmonthlyReimburseBtn(true);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
							})
					: axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum + 1
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&EmployeeId=${
									employeeId.value
								}&StartDate=${moment(startDate).format(
									"YYYY-MM-DD"
								)}&EndDate=${moment(endDate).format(
									"YYYY-MM-DD"
								)}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setIsGeneralReimbLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setmonthlyReimburse(data.reimbursements);
								setmonthlyReimburseBtn(true);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
							});
			} else {
				!monthChange
					? axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum + 1
								}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}&EmployeeId=${employeeId.value}&SortBy=${
									sortBy.dataField
								}_${sortBy.order}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
								setIsGeneralReimbLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setmonthlyReimburse(data.reimbursements);
								setmonthlyReimburseBtn(true);
							})
					: !employeeId && monthChange
					? axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum + 1
								}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setIsGeneralReimbLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setmonthlyReimburse(data.reimbursements);
								setmonthlyReimburseBtn(true);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
							})
					: axios
							.get(
								`${
									ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
								}?Status=${
									status.value
								}&PageSize=${numberOfItemsPerPage}&PageNumber=${
									pageNum + 1
								}&SortBy=${sortBy.dataField}_${
									sortBy.order
								}&Year=${selectedYear.value}&Month=${
									selectedMonth.value
								}&EmployeeId=${employeeId.value}`,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data, headers }) => {
								setIsLoading(false);
								setIsGeneralReimbLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setmonthlyReimburse(data.reimbursements);
								setmonthlyReimburseBtn(true);
								setPagerData(
									JSON.parse(headers["x-pagination"])
								);
							});
			}
		}
	};
	const onMasterCheck = (e) => {
		let tempList = monthlyReimburse ? monthlyReimburse : generalReimburse;
		setSingleRecordID([]);
		tempList.map((item) => {
			item.selected = e.target.checked;
		});
		monthlyReimburse
			? setmonthlyReimburse(tempList)
			: setgeneralReimburse([]);
		!monthlyReimburse &&
			setTimeout(() => {
				setgeneralReimburse(tempList);
			});
		monthlyReimburse
			? setMultipleRecords(monthlyReimburse.filter((e) => e.selected))
			: setMultipleRecords(generalReimburse.filter((e) => e.selected));
		if (monthlyReimburse) {
			if (monthlyReimburse.length === 0) {
				setMasterChecked(false);
				setIsDisabled(true);
			} else {
				setMasterChecked(e.target.checked);
				if (e.target.checked) {
					setIsDisabled(false);
				} else {
					setIsDisabled(true);
				}
			}
		} else {
			if (generalReimburse.length === 0) {
				setMasterChecked(false);
				setIsDisabled(true);
			} else {
				setMasterChecked(e.target.checked);
				if (e.target.checked) {
					setIsDisabled(false);
				} else {
					setIsDisabled(true);
				}
			}
		}
	};

	const setBulkStatus = (status) => {
		setMasterChecked(null);
		let idNum = multipleRecords.map((data) => {
			const { appID } = data;
			return appID;
		});

		const body = {
			monthlyReimbursements: idNum,
			submissionStatus: status,
		};
		const body2 = {
			generalReimbursements: idNum,
			submissionStatus: status,
		};
		const singleRecordBody = {
			submissionStatus: status,
		};
		singleRecordID && monthlyReimburse && !selectedList
			? axios
					.patch(
						`${ReimbursementAPIs.ChangeMonthlyReimbursementStatus}/${singleRecordID}/ChangeStatus`,
						singleRecordBody,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(() => {
						getAllEmpMonthlyReimbursementList();
						setMasterChecked(false);
						setIsDisabled(true);
					})
			: axios
					.patch(
						`${ReimbursementAPIs.ChangeGeneralReimbursementStatus}/${singleRecordID}/ChangeStatus`,
						singleRecordBody,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(() => {
						getAllEmpGeneralReimbursementList();
						setMasterChecked(false);
						setgeneralReimburse([]);
						setIsDisabled(true);
					});
		monthlyReimburse
			? axios
					.patch(
						`${ReimbursementAPIs.ChangeMonthlyReimbursementStatusInBulk}`,
						body,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(() => {
						getAllEmpMonthlyReimbursementList();
						setMasterChecked(false);
						setIsDisabled(true);
					})
			: axios
					.patch(
						`${ReimbursementAPIs.ChangeGeneralReimbursementStatusInBulk}`,
						body2,
						{ headers: { Authorization: `Bearer ${token}` } }
					)
					.then(() => {
						getAllEmpGeneralReimbursementList();
						setMasterChecked(false);
						setgeneralReimburse(null);
						setIsDisabled(true);
					});
		setSelectedList([]);
	};

	const exportToExcel = () => {
		monthlyReimburseBtn
			? employeeId &&
			  selectedMonth &&
			  selectedYear &&
			  status &&
			  axios({
					url: `${
						ReimbursementAPIs.MonthlyReimbursementExportToExcel
					}?Status=${status.value}&StartDate=${moment(
						startDate
					).format("YYYY-MM-DD")}&EndDate=${moment(endDate).format(
						"YYYY-MM-DD"
					)}&EmployeeID=${employeeId.value}&Month=${
						selectedMonth.value
					}`, //your url
					method: "GET",
					responseType: "blob",
					headers: {
						Authorization: `Bearer ${token}`,
					},
			  })
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"MonthlyReimbursement.xlsx"
						);
						document.body.appendChild(link);
						link.click();
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: "Please Select Date",
							});
						}
					})
			: employeeId &&
			  selectedMonth &&
			  selectedYear &&
			  status &&
			  axios({
					url: `${
						ReimbursementAPIs.GeneralReimbursementExportToExcel
					}?Status=${status.value}&StartDate=${moment(
						startDate
					).format("YYYY-MM-DD")}&EndDate=${moment(endDate).format(
						"YYYY-MM-DD"
					)}&EmployeeID=${employeeId.value}&Month=${
						selectedMonth.value
					}`, //your url
					method: "GET",
					responseType: "blob",
					headers: {
						Authorization: `Bearer ${token}`,
					},
			  })
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"GeneralReimbursement.xlsx"
						);
						document.body.appendChild(link);
						link.click();
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: "Please Select Date",
							});
						}
					});

		monthlyReimburse
			? !employeeId &&
			  monthChange &&
			  axios({
					url: `${
						ReimbursementAPIs.MonthlyReimbursementExportToExcel
					}?Status=${status.value}&StartDate=${moment(
						startDate
					).format("YYYY-MM-DD")}&EndDate=${moment(endDate).format(
						"YYYY-MM-DD"
					)}&Month=${selectedMonth.value}`, //your url
					method: "GET",
					responseType: "blob",
					headers: {
						Authorization: `Bearer ${token}`,
					},
			  })
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"MonthlyReimbursement.xlsx"
						);
						document.body.appendChild(link);
						link.click();
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: "Please Select Date",
							});
						}
					})
			: !employeeId &&
			  monthChange &&
			  axios({
					url: `${
						ReimbursementAPIs.GeneralReimbursementExportToExcel
					}?Status=${status.value}&StartDate=${moment(
						startDate
					).format("YYYY-MM-DD")}&EndDate=${moment(endDate).format(
						"YYYY-MM-DD"
					)}&Month=${selectedMonth.value}`, //your url
					method: "GET",
					responseType: "blob",
					headers: {
						Authorization: `Bearer ${token}`,
					},
			  })
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"GeneralReimbursement.xlsx"
						);
						document.body.appendChild(link);
						link.click();
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: "Please Select Date",
							});
						}
					});
		monthlyReimburse
			? !employeeId &&
			  !monthChange &&
			  axios({
					url: `${
						ReimbursementAPIs.MonthlyReimbursementExportToExcel
					}?Status=${status.value}&StartDate=${moment(
						startDate
					).format("YYYY-MM-DD")}&EndDate=${moment(endDate).format(
						"YYYY-MM-DD"
					)}`, //your url
					method: "GET",
					responseType: "blob",
					headers: {
						Authorization: `Bearer ${token}`,
					},
			  })
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"MonthlyReimbursement.xlsx"
						);
						document.body.appendChild(link);
						link.click();
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: "Please Select Date",
							});
						}
					})
			: !employeeId &&
			  !monthChange &&
			  axios({
					url: `${
						ReimbursementAPIs.GeneralReimbursementExportToExcel
					}?Status=${status.value}&StartDate=${moment(
						startDate
					).format("YYYY-MM-DD")}&EndDate=${moment(endDate).format(
						"YYYY-MM-DD"
					)}`, //your url
					method: "GET",
					responseType: "blob",
					headers: {
						Authorization: `Bearer ${token}`,
					},
			  })
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"GeneralReimbursement.xlsx"
						);
						document.body.appendChild(link);
						link.click();
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: "Please Select Date",
							});
						}
					});
	};

	const printReimbursementForm = () => {
		setIsSubmitting(true);
		setIsDisabled(false);
		let id = [];
		let generalReimbursement = "";
		let monthlyReimbursement = "";

		multipleRecords
			? (id = multipleRecords.map((data) => {
					return (generalReimbursement =
						generalReimbursement +
						`ReimbursementID=${data.appID}&`);
			  }))
			: (id = multipleRecords.map((data) => {
					return (generalReimbursement =
						generalReimbursement +
						`ReimbursementID=${multipleRecords[0].appID}&`);
			  }));

		multipleRecords
			? (id = multipleRecords.map((data) => {
					return (monthlyReimbursement =
						monthlyReimbursement +
						`ReimbursementIDs=${data.appID}&`);
			  }))
			: (monthlyReimbursement = `ReimbursementIDs=${multipleRecords[0].appID}&`);

		monthlyReimburseBtn
			? axios
					.get(
						`${
							ReimbursementAPIs.PrintMonthlyReimbursementForm
						}?${monthlyReimbursement.slice(0, -1)}`,
						{
							headers: { Authorization: `Bearer ${token}` },
							responseType: "blob",
						}
					)
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"MonthlyReimbursement.pdf"
						);
						document.body.appendChild(link);
						link.click();
						setIsSubmitting(false);
						setIsDisabled(true);
						getAllEmpMonthlyReimbursementList();
						setMasterChecked(false);
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: `${err.response.data.message}`,
							});
						}
					})
			: axios
					.get(
						`${
							ReimbursementAPIs.PrintGeneralReimbursementForm
						}?${generalReimbursement.slice(0, -1)}`,
						{
							headers: { Authorization: `Bearer ${token}` },
							responseType: "blob",
						}
					)
					.then((response) => {
						const url = window.URL.createObjectURL(
							new Blob([response.data])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute(
							"download",
							"GeneralReimbursement.pdf"
						);
						document.body.appendChild(link);
						link.click();
						setIsSubmitting(false);
						getAllEmpGeneralReimbursementList();
						setMasterChecked(false);
						setgeneralReimburse([]);
					})
					.catch((err) => {
						if (err.response) {
							AlertPopups.ErrorAlert.fire({
								text: `${err.response.data.message}`,
							});
						}
					});
	};
	const onStartDateChange = (date) => {
		let year = date.getFullYear();
		setSelectedYear({ value: year, label: year.toString() });
		setStartDate(date);
		setIsGeneralReimbLoading(true);
		setMonthlyReimbursementTableLoader(true);

		if (empDepartment === "5") {
			monthlyReimburse
				? axios
						.get(
							`${
								ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
							}?Status=${
								status.value
							}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${year}&EmployeeID=${
								employeeId.value
							}&Month=${selectedMonth.value}&StartDate=${moment(
								date
							).format("YYYY-MM-DD")}&EndDate=${moment(
								endDate
							).format("YYYY-MM-DD")}`,
							{ headers: { Authorization: `Bearer ${token}` } }
						)
						.then(({ data, headers }) => {
							setPagerData(JSON.parse(headers["x-pagination"]));
							setMonthlyReimbursementTableLoader(false);
							setIsGeneralReimbLoading(false);
							setmonthlyReimburse(data.reimbursements);
							setmonthlyReimburseBtn(true);
						})
				: axios
						.get(
							`${
								ReimbursementAPIs.GetAllEmpGeneralReimbursementList
							}?Status=${
								status.value
							}&PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&Year=${year}&SortBy=${
								sortBy.dataField
							}_${sortBy.order}&StartDate=${moment(date).format(
								"YYYY-MM-DD"
							)}&EndDate=${moment(endDate).format(
								"YYYY-MM-DD"
							)}&Month=${selectedMonth.value}&EmployeeID=${
								employeeId.value
							}`,
							{ headers: { Authorization: `Bearer ${token}` } }
						)
						.then(({ data, headers }) => {
							setgeneralReimburse(data.reimbursements);
							setIsGeneralReimbLoading(false);
							setMonthlyReimbursementTableLoader(false);
							setmonthlyReimburseBtn(false);
							setPagerData(JSON.parse(headers["x-pagination"]));
							setIsLoading(false);
						});
		} else {
			monthlyReimburse
				? axios
						.get(
							`${ReimbursementAPIs.GetMonthlyReimbursement}?PageSize=${numberOfItemsPerPage}&PageNumber=1&EmployeeID=${employeeId.value}&Month=${selectedMonth.value}`,
							{
								headers: { Authorization: `Bearer ${token}` },
							}
						)
						.then((res) => {
							if (res.status === 200) {
								setIsLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setIsGeneralReimbLoading(false);
								setmonthlyReimburse(res.data.reimbursements);
							}
							if (res.data.reimbursements.length) {
								setIsDataFound(true);
							}
						})
				: axios
						.get(
							`${ReimbursementAPIs.GetGeneralReimbursement}?PageSize=20&SortBy=${sortBy.dataField}_${sortBy.order}`,
							{
								headers: { Authorization: `Bearer ${token}` },
							}
						)
						.then((res) => {
							if (res.data.reimbursements.length) {
								setIsDataFound(true);
								setPagerData(
									JSON.parse(res.headers["x-pagination"])
								);
								setMonthlyReimbursementTableLoader(false);
								setIsGeneralReimbLoading(false);
								setgeneralReimburse(res.data.reimbursements);
							}
						});
		}
	};
	const onEndDateChange = (date) => {
		let year = date.getFullYear();
		setSelectedYear({ value: year, label: year.toString() });
		setEndDate(date);
		setIsGeneralReimbLoading(true);
		setMonthlyReimbursementTableLoader(true);

		if (empDepartment === "5") {
			monthlyReimburse
				? axios
						.get(
							`${
								ReimbursementAPIs.GetAllEmpMonthlyReimbursementList
							}?Status=${
								status.value
							}&PageSize=${numberOfItemsPerPage}&PageNumber=${1}&Year=${year}&EmployeeID=${
								employeeId.value
							}&Month=${selectedMonth.value}&StartDate=${moment(
								startDate
							).format("YYYY-MM-DD")}&EndDate=${moment(
								date
							).format("YYYY-MM-DD")}`,
							{ headers: { Authorization: `Bearer ${token}` } }
						)
						.then(({ data, headers }) => {
							setPagerData(JSON.parse(headers["x-pagination"]));
							setMonthlyReimbursementTableLoader(false);
							setIsGeneralReimbLoading(false);
							setmonthlyReimburse(data.reimbursements);
							setmonthlyReimburseBtn(true);
						})
				: axios
						.get(
							`${
								ReimbursementAPIs.GetAllEmpGeneralReimbursementList
							}?Status=${
								status.value
							}&PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&EmployeeID=${
								employeeId.value
							}&Month=${
								selectedMonth.value
							}&Year=${year}&SortBy=${sortBy.dataField}_${
								sortBy.order
							}&StartDate=${moment(startDate).format(
								"YYYY-MM-DD"
							)}&EndDate=${moment(date).format("YYYY-MM-DD")}`,
							{ headers: { Authorization: `Bearer ${token}` } }
						)
						.then(({ data, headers }) => {
							setgeneralReimburse(data.reimbursements);
							setIsGeneralReimbLoading(false);
							setMonthlyReimbursementTableLoader(false);
							setmonthlyReimburseBtn(false);
							setPagerData(JSON.parse(headers["x-pagination"]));
							setIsLoading(false);
						});
		} else {
			monthlyReimburse
				? axios
						.get(
							`${ReimbursementAPIs.GetMonthlyReimbursement}?PageSize=${numberOfItemsPerPage}&PageNumber=1&EmployeeID=${employeeId.value}&Month=${selectedMonth.value}`,
							{
								headers: { Authorization: `Bearer ${token}` },
							}
						)
						.then((res) => {
							if (res.status === 200) {
								setIsLoading(false);
								setIsGeneralReimbLoading(false);
								setMonthlyReimbursementTableLoader(false);
								setmonthlyReimburse(res.data.reimbursements);
							}
							if (res.data.reimbursements.length) {
								setIsDataFound(true);
							}
						})
				: axios
						.get(
							`${ReimbursementAPIs.GetGeneralReimbursement}?PageSize=20&SortBy=${sortBy.dataField}_${sortBy.order}`,
							{
								headers: { Authorization: `Bearer ${token}` },
							}
						)
						.then((res) => {
							if (res.data.reimbursements.length) {
								setIsDataFound(true);
								setPagerData(
									JSON.parse(res.headers["x-pagination"])
								);
								setMonthlyReimbursementTableLoader(false);
								setIsGeneralReimbLoading(false);
								setgeneralReimburse(res.data.reimbursements);
							}
						});
		}
	};
	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (empDepartment != "5") {
			if (monthlyReimburse) {
				if (sessionStorage.getItem("MyMonthlyReimbFilter"))
					obj = JSON.parse(
						sessionStorage.getItem("MyMonthlyReimbFilter")
					);
				if (property === "status") obj[0] = value;
				else if (property === "year") obj[1] = value;
				sessionStorage.setItem(
					"MyMonthlyReimbFilter",
					JSON.stringify(obj)
				);
			} else {
				if (sessionStorage.getItem("MyGeneralReimbFilter"))
					obj = JSON.parse(
						sessionStorage.getItem("MyGeneralReimbFilter")
					);
				if (property === "status") obj[0] = value;
				else if (property === "year") obj[1] = value;
				sessionStorage.setItem(
					"MyGeneralReimbFilter",
					JSON.stringify(obj)
				);
			}
		}
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				joiningDate = userDetails.empJoinedOn.split("-")[0];
				empDepartment = userDetails.department;
				return (
					<div className="container-fluid pl-3 pr-3">
						<ReimbursementButton
							monthlyReimburse={getmonthlyReimburse}
							generalReimburse={getGeneralReimburse}
							monthlyReimburseBtn={monthlyReimburseBtn}
							generalReimburseBtn={generalReimburseBtn}
							getAllEmpGeneralReimbursementList={
								getAllEmpGeneralReimbursementList
							}
							empDepartment={empDepartment}
						/>
						<ReimbursementBar
							getStatus={reimbursementStatus}
							handleStatus={handleStatus}
							byYearHandler={byYearHandler}
							getByYear={getByJoiningDate.sort(
								(a, b) => a.label - b.label
							)}
							monthlyReimburse={monthlyReimburse}
							generalReimburse={generalReimburse}
							viewMonthlyReimburseDetails={
								viewMonthlyReimburseDetails
							}
							employeesList={employeesList}
							getEmployeeID={getEmployeeID}
							empDepartment={empDepartment}
							monthsList={monthsList}
							setSubmissionStatus={setSubmissionStatus}
							byMonthHanlder={byMonthHanlder}
							selectedYear={selectedYear}
							selectedMonth={selectedMonth}
							status={status}
							employeeId={employeeId}
							years={years}
							allEmployeesList={allEmployeesList}
							startDate={startDate}
							endDate={endDate}
							onStartDateChange={onStartDateChange}
							onEndDateChange={onEndDateChange}
						/>
						{empDepartment === "5" && (
							<div className="mt-4 ApprovalBtnsdiv">
								<div>
									<Button
										className="financeSubmit-btn"
										onClick={() => setBulkStatus(1)}
										disabled={isDisabled ? true : false}
									>
										Set as Pending
									</Button>
								</div>
								<div>
									<Button
										className="financeSubmit-btn"
										onClick={() => setBulkStatus(5)}
										disabled={isDisabled ? true : false}
									>
										Set as Processing
									</Button>
								</div>
								<div>
									<Button
										onClick={() => setBulkStatus(2)}
										className="financeSubmit-btn"
										disabled={isDisabled ? true : false}
									>
										Set as Approved
									</Button>
								</div>
								<div>
									<Button
										onClick={() => setBulkStatus(4)}
										className="financeSubmit-btn"
										disabled={isDisabled ? true : false}
									>
										Set as Paid
									</Button>
								</div>
								<div>
									<Button
										onClick={() => setBulkStatus(3)}
										className="reject-btn"
										disabled={isDisabled ? true : false}
									>
										Set as Rejected
									</Button>
								</div>
								<div>
									<Button
										onClick={() => exportToExcel()}
										className="financeSubmit-btn"
									>
										Export To Excel
									</Button>
								</div>

								<div lg={3}>
									<Button
										onClick={printReimbursementForm}
										className="financeSubmit-btn"
										disabled={isDisabled ? true : false}
									>
										{isSubmitting ? (
											<>
												<span
													class="spinner-border spinner-border-sm"
													role="status"
													aria-hidden="true"
												></span>
												<span>
													Print Reimbursement Form
												</span>
											</>
										) : (
											<span>
												Print Reimbursement Form
											</span>
										)}
									</Button>
								</div>
							</div>
						)}
						<ReimbursementTable
							setgeneralReimburseBtn={(value) =>
								setgeneralReimburseBtn(value)
							}
							monthlyReimburse={monthlyReimburse}
							generalReimburse={generalReimburse}
							numberOfItemsPerPage={numberOfItemsPerPage}
							isDataFound={isDataFound}
							viewMonthlyReimburseDetails={
								viewMonthlyReimburseDetails
							}
							viewGeneralReimburseDetails={
								viewGeneralReimburseDetails
							}
							pageNum={pageNum}
							handleTableChange={handleTableChange}
							pageSizeOptions={pageSizeOptions}
							columns={columns}
							defaultSorted={defaultSorted}
							pagerData={pagerData}
							receiveData={receiveData}
							isLoaded={isLoaded}
							empDepartment={empDepartment}
							getSpecificReimbursementRecord={
								getSpecificReimbursementRecord
							}
							menuProps={
								empDepartment === "5"
									? adminMenuProps
									: menuProps
							}
							paginateLeft={paginateLeft}
							paginateRight={paginateRight}
							onMasterCheck={onMasterCheck}
							masterChecked={masterChecked}
							columnsForFinance={columnsForFinance}
							isLoading={isLoading}
							isGeneralReimbLoading={isGeneralReimbLoading}
							years={years}
							MonthlyReimbursementTableLoader={
								MonthlyReimbursementTableLoader
							}
						/>
					</div>
				);
			}}
		</UserConsumer>
	);
};

export default MyReimbursement;
